import { FC } from 'react'
import cn from 'classnames'
import styles from 'components/features/pfm/ActionMenu/ActionIcon.styl'

type ActionIconProps = {
  className?: string
}

export const ActionIcon: FC<ActionIconProps> = (props) => {
  const { className } = props

  return (
    <div className={ cn(styles.container, className) } />
  )
}
